// ===============================
// CartContext.jsx
// ===============================

import React, {
  createContext,
  useEffect,
  useState,
} from "react";
import toast from "react-hot-toast";
export const CartContext =
  createContext();

const CartProvider = ({
  children,
}) => {

  // ===============================
  // CART STATE
  // ===============================

  const [cartItems, setCartItems] =
    useState(() => {

      const storedCart =
        localStorage.getItem("cartItems");

      return storedCart
        ? JSON.parse(storedCart)
        : [];

    });

  // ===============================
  // SAVE TO LOCAL STORAGE
  // ===============================

  useEffect(() => {

    localStorage.setItem(
      "cartItems",
      JSON.stringify(cartItems)
    );

  }, [cartItems]);

  // ===============================
  // ADD TO CART
  // ===============================

 // ===============================
// ADD TO CART
// ===============================

// ===============================
// ADD TO CART
// ===============================

const addToCart = (product) => {

  const exist =
    cartItems.find(
      (item) =>
        item._id === product._id
    );

  // DEFAULT QUANTITY

  const qty =
    product.quantity || 1;

  if (exist) {

    setCartItems(

      cartItems.map((item) =>

        item._id === product._id
          ? {

              ...item,

              quantity:
                Number(item.quantity || 1) +
                Number(qty),

            }
          : item

      )

    );

    toast.success(
      `${product.name} quantity updated`
    );

  } else {

    setCartItems([

      ...cartItems,

      {

        ...product,

        quantity: qty,

      },

    ]);

    toast.success(
      `${product.name} added to cart`
    );

  }

};
  // ===============================
  // REMOVE FROM CART
  // ===============================

 const removeFromCart = (id) => {

  const removedProduct =
    cartItems.find(
      (item) => item._id === id
    );

  setCartItems(

    cartItems.filter(
      (item) => item._id !== id
    )

  );

  toast.error(
    `${removedProduct.name} removed`
  );

};

  // ===============================
  // INCREASE QTY
  // ===============================

  const increaseQty = (id) => {

    setCartItems(

      cartItems.map((item) =>

        item._id === id
          ? {
              ...item,
              quantity:
                item.quantity + 1,
            }
          : item

      )

    );

  };

  // ===============================
  // DECREASE QTY
  // ===============================

  const decreaseQty = (id) => {

    setCartItems(

      cartItems.map((item) =>

        item._id === id
          ? {
              ...item,
              quantity:
                item.quantity > 1
                  ? item.quantity - 1
                  : 1,
            }
          : item

      )

    );

  };

  // ===============================
  // TOTAL ITEMS
  // ===============================

  const totalItems =
    cartItems.reduce(

      (acc, item) =>
        acc + item.quantity,

      0

    );

  // ===============================
  // TOTAL PRICE
  // ===============================

  const totalPrice =
    cartItems.reduce(

      (acc, item) =>

        acc +
        item.price *
          item.quantity,

      0

    );

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        increaseQty,
        decreaseQty,
        totalItems,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;